import React, { useEffect, useState } from 'react';
import { LoginFromStyle } from './LoginForm.style';
import { useForm } from 'react-hook-form';
import { NavLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import image from "../../Assets/fjordland_logo_fritlagt.png";
import SuccesCheckmarkLogin from '../SuccesCheckmarkLogin/SuccesCheckmarkLogin';

function LoginForm() {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const navigate = useNavigate();
    const [emailError, setEmailError] = useState(false);
    const [loginError, setLoginError] = useState(false);
    const [bannedError, setBannedError] = useState(false);
    const [showCheckmark, setShowCheckmark] = useState(false);
    const [loginAttempt, setLoginAttempt] = useState(Date.now() - new Date(JSON.parse(localStorage.getItem('loginAttempt'))) > 5 * 60 * 1000 ? 1 : 5);
    console.log(Date.now() - new Date(JSON.parse(localStorage.getItem('loginAttempt'))) > 5 * 60 * 1000);
    console.log(JSON.parse(localStorage.getItem('loginAttempt')));
    
    useEffect(() => {
        if (sessionStorage.getItem('user')) {
            navigate('/dashboard');
        }
    }, [navigate]);

    const submitForm = async (data) => {

            try {
            console.log('Submitting data:', data); // Log data to verify it is correct

            const response = await axios.post('https://api.agrop.eu/login', {
                email: data.email,
                password: data.password
            });
            console.log(response);
            if (response.status === 200) {
                
                if (data.email.includes('@kvxp.dk') || data.email.includes('@fjordland.dk')) {
                  setShowCheckmark(true)      
                }else{
                    setLoginError(true);
                }
                setTimeout(() => {
                
                if (data.email.includes('@kvxp.dk') || data.email.includes('@fjordland.dk')) {
                    navigate('/dashboard'); 
                    sessionStorage.setItem('user', JSON.stringify(response.data));
                } 
                }, 1000);

            } else if (response.data.banned) {
                setBannedError(true);

            }else {
                setLoginError(true);
                setLoginAttempt(loginAttempt + 1)
                console.log(loginAttempt);
                
            }
        } catch (error) {
            if (loginAttempt < 4) {
              setLoginError(true);  
            }else{
                setLoginError(false); 
                localStorage.setItem("loginAttempt", JSON.stringify(new Date))
                console.log(JSON.parse(localStorage.getItem('loginAttempt')));
                
            }
            
            console.error('Login error:', error);
            setLoginAttempt(loginAttempt + 1)
            console.log(loginAttempt);
        }


    };

    return (
        <LoginFromStyle>
            <form onSubmit={handleSubmit(submitForm)}>
                <h1>AgroProtect</h1>
                <div className='headingDiv'>
                    <img src={image} alt="logo" />
                </div>
                <label htmlFor="email">Brugernavn</label>
                <input type="text" name="email" id='email' placeholder='Email' {...register('email', { required: true })} />
                <label htmlFor="password">Kodeord</label>
                <input type="password" id='password' name="password" placeholder='Password' {...register('password', { required: true })} />
                <p id="forgotPass" >Glemt dit kodeord?</p>
                {errors.email && <span>Email skal udfyldes!</span>}
                {emailError && <span>Din email er ikke fra kvægexperten eller fjordland!</span>}
                {errors.password && <span>Kodeord skal udfyldes!</span>}
                {loginError && <span id='loginError'>Kodeord eller brugernavn findes ikke eller er forkert</span>}
                {bannedError && <span id='banned'>Din konto er ikke aktiv. Hvis du mener dette er en fejl kan du kontakte en administrator.</span>}
                {loginAttempt > 4 && <span id='tooManylogin'>Du har skrevet en forkert kode for mange gange. Vent 5 minutter før du prøver igen. Prøv "Glemt dit kodeord?" hvis du ikke kan huske den.</span>}
                {loginAttempt < 5 ? <button type='submit'>Login</button> : null}
                {showCheckmark ? <SuccesCheckmarkLogin /> : null}
            </form>
        </LoginFromStyle>
    );
}

export default LoginForm;
